import { render, staticRenderFns } from "./dmAlertModal.vue?vue&type=template&id=107f747c"
import script from "./dmAlertModal.vue?vue&type=script&lang=js"
export * from "./dmAlertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports